var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRojobcardEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#FF6019",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 31.6667H36C33.2386 31.6667 31 33.9053 31 36.6667V53.3334C31 56.0948 33.2386 58.3334 36 58.3334H56C58.7614 58.3334 61 56.0948 61 53.3334V36.6667C61 33.9053 58.7614 31.6667 56 31.6667Z",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0003 44.9999C42.8413 44.9999 44.3337 43.5075 44.3337 41.6666C44.3337 39.8256 42.8413 38.3333 41.0003 38.3333C39.1594 38.3333 37.667 39.8256 37.667 41.6666C37.667 43.5075 39.1594 44.9999 41.0003 44.9999Z",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38.3333H54.3333",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45H54.3333",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.667 51.6667H54.3337",
    stroke: "#FF6019",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRojobcardEmpty);
export default __webpack_public_path__ + "static/media/rojobcardEmpty.1dbcbd48.svg";
export { ForwardRef as ReactComponent };